<template>
  <div class="kefu">
    <el-page-header @back="$router.back()" content="违规举报"></el-page-header>
    <div class="main" style="margin-top: 30px;">
      <el-form v-if="type === 0" label-width="120px">
        <el-form-item label="举报的账号">
          <el-input v-model="form.jubao_user" placeholder="请输入被举报的账号"></el-input>
        </el-form-item>
        <el-form-item label="违规内容地址">
          <el-input v-model="form.jubao_url" placeholder="请输入违规内容的链接地址"></el-input>
        </el-form-item>
        <el-form-item label="截图">
          <el-upload
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="handleChange"
            :file-list="filelist"
            :limit="4"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="举报描述">
          <el-input type="textarea" :rows="10" v-model="form.jubao_content" placeholder="请输入反馈的内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
      <div v-else style="text-align: center; padding: 60px 0;">
        <el-button type="success" icon="el-icon-check" circle size="medium"></el-button>
        <h3 style="margin: 16px 0 8px;">举报成功</h3>
        <p style="color: #999; font-size: 14px;">平台会根据违规程度进行时间不等的封号处理，处理结果可在「账号申诉」页面查看</p>
        <el-button style="margin-top: 20px;" @click="$router.push('/')">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createJubao } from '@/api'

export default {
  name: 'Jubao',
  data() {
    return {
      type: 0,
      filelist: [],
      form: { jubao_user: '', jubao_url: '', jubao_content: '', jubao_img: [] }
    }
  },
  created() {
    if (this.$route.query.user || this.$route.query.url) {
      this.form.jubao_user = this.$route.query.user || ''
      if (this.$route.query.url) {
        try { this.form.jubao_url = decodeURIComponent(this.$route.query.url) } catch (e) { this.form.jubao_url = this.$route.query.url }
      }
    }
  },
  methods: {
    handleChange(file, fileList) {
      this.filelist = fileList
      this.form.jubao_img = fileList.filter((f) => f.raw).map((f) => URL.createObjectURL(f.raw))
    },
    submit() {
      if (!this.form.jubao_user || !this.form.jubao_content) {
        this.$message.error('请填写完整信息')
        return
      }
      createJubao({ ...this.form, jubao_img: JSON.stringify(this.form.jubao_img), jubao_type: 'jubao' }).then(() => {
        this.type = 1
      })
    }
  }
}
</script>
